'use strict';

angular.module('atex.dam').controller('DamEditByIdController', ['$scope', '$rootScope', 'ContentService', '$state', '$stateParams',
  function($scope, $rootScope, ContentService, $state, $stateParams) {
	var entries = [];
	
    ContentService.getContent({id : $stateParams.id}).then(function(response) {
      response._data = response.data;
      entries.push(response);
      $state.go('list.edit', { ids : entries });
    }).then(null, function(error) {
      $state.go('list');
    });
}]);

